// GENERATED FILE — do not edit. Produced by scripts/generate-version.js
export const VERSION: string = '1.0.0';
export const BUILD: string = '83';
export const COMMIT: string = '0134484';
export const BRANCH: string = 'master';
export const ENVIRONMENT: string = 'production';
export const BUILT_AT: string = '2026-11-05T06:54:27.360Z';

/** Customer-facing release, e.g. "2026.45.1", and the date it was built/deployed. */
export const RELEASE: string = '2026.45.6';
export const RELEASE_DATE: string = '5 Nov 2026';
export const RELEASE_STRING: string = `${RELEASE} · ${RELEASE_DATE}`;

/** e.g. "v0.2.0 · build 168 · a3f9c21 · development" */
export const VERSION_STRING: string = `v${VERSION} · build ${BUILD} · ${COMMIT} · ${ENVIRONMENT}`;
